import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { faAngleDown, faAngleUp, faSearch } from '@fortawesome/pro-light-svg-icons';
import { select, Store } from '@ngrx/store';
import { rollupTabCollapseLocationAndEditionInformation, tryToGetIt } from 'app/entity/actions/entity.actions';
import {
  loadRelatedItemsOfMaterialTabEditions,
  queryEditions,
  updateEditionAvailabilityState
} from 'app/entity/actions/full-entity.actions';
import { AvailabilityUpdateInfo, GetItRequest, HoldRequest, MaterialTab } from 'app/entity/models/entity';
import { getSelectedRollupTab } from 'app/entity/reducers/entity.reducer';
import { debounceTime, first, Subject, Subscription } from 'rxjs';
import { SelectedRollUpTab } from 'search/models/search-results';
import { ConfigurationLoader } from 'shared/configuration-loader';
import { VendorLogo } from 'shared/models/configuration';

@Component({
  selector: 'app-rollup-tabs-content-card-header-rapido',
  templateUrl: './rollup-tabs-content-card-header-rapido.component.html',
  styleUrls: ['./rollup-tabs-content-card-header-rapido.component.scss']
})
export class RollupTabsContentCardHeaderRapidoComponent implements OnInit, OnDestroy {
  @Input() public materialTab: MaterialTab;
  @Input() public availabilityUpdateInfo: AvailabilityUpdateInfo;
  @Input() public fgId: string;
  @Input() public fgTitle: string;
  @Input() public rollupTabIndex: number;
  @Input() public visible: boolean;
  @Input() public language: string;
  @Input() public hasEcontentIssues: boolean;
  @Input() public isbn: string;
  @Output() public getIt = new EventEmitter(true);
  @Output() public getIt$ = new EventEmitter<{item: GetItRequest}>(true);
  @Output() public placeHold$ = new EventEmitter<{item: HoldRequest}>(true);
  @Output() public tableInited = new EventEmitter();
  @Output() public onEditionsSearch$ = new EventEmitter<string>();

  public tableExpanded: boolean;
  public vendorsLogo: { [key: string]: string };

  public readonly arrowIconDown = faAngleDown;
  public readonly arrowIconUp = faAngleUp;
  public readonly searchIcon = faSearch;
  public editionsSearchInputDebouncer = new Subject<string>();
  public nonIntegratedLogo: { [key: string]: VendorLogo }
  public isElectronic = false;

  @ViewChild('editionsSearchInput') private editionsSearchInput: ElementRef;

  @ViewChild('getItButton', { read: ElementRef }) private getItButton: ElementRef;
  private subscriptions = new Subscription();

  public constructor(
    private store: Store,
    private configLoader: ConfigurationLoader,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  public ngOnInit() {
    this.vendorsLogo = this.configLoader.vendorsLogo;
    this.nonIntegratedLogo = this.configLoader.nonIntegratedConnectionsLogoMapping;

    this.subscriptions.add(this.store.pipe(
      select(getSelectedRollupTab(this.fgId)),
    ).pipe(
      debounceTime(300),
      first(),
    ).subscribe((selected: SelectedRollUpTab) => {
      if (this.shouldExpand(selected)) {
        this.tableExpanded = true;
        this.cdRef.markForCheck();
      }
    }));

    this.editionsSearchInputDebouncer.pipe(
      debounceTime(500)
    ).subscribe(value => {
      if (value !== null && value !== undefined) {
        this.store.dispatch(queryEditions({query:value}));
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.store.dispatch(rollupTabCollapseLocationAndEditionInformation({
      resourceId: this.fgId,
      tabIndex: this.rollupTabIndex,
    }));
  }

  public toggleLocationAndEditionInfo() {
    this.tableExpanded = !this.tableExpanded;
  }

  public onGetIt(edition: any) {
    this.store.dispatch(tryToGetIt({
      item: edition,
    }));
  }

  public onCheckEditions() {
    this.tableExpanded = true;
  }

  public onTableInited() {
    this.tableInited.emit();
  }

  public onEditionsSearch(query: string) {
    if (query) {
      this.tableExpanded = true;
    }
    this.editionsSearchInputDebouncer.next(query);
  }

  private shouldExpand(selectedElement: SelectedRollUpTab) {
    return selectedElement && (selectedElement.selectedIndex === this.rollupTabIndex && selectedElement.expandLocationAndEditionInformation);
  }
}
